import React from "react";
import { ButtonStyled } from "./button.style";
import { CircularProgress } from "@mui/material";

export const Button = ({
  type = "button",
  size = "small",
  variant = "contained",
  color,
  disableRipple = true,
  isLoading,
  startIcon,
  children,
  endIcon,
  ...rest
}) => (
  <div>
    <ButtonStyled
      {...rest}
      type={type}
      variant={variant}
      color={color}
      size={size}
      disableRipple={disableRipple}
      startIcon={
        isLoading ? <CircularProgress size={10} color={"inherit"} /> : startIcon
      }
      endIcon={endIcon}
      isLoading={isLoading}
    >
      {children}
    </ButtonStyled>
  </div>
);
